module.exports = __webpack_public_path__ + "assets/img/4.194248a6.jpg";